module.exports = __webpack_public_path__ + "img/terminal-T10-F.4ed23e75.png";